import { render } from "./App.vue?vue&type=template&id=6b0e0e01"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6b0e0e01&lang=scss"

import exportComponent from "/Users/mingyanglezhao/silva/workSP/yemei-font/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__